<div class="modal-content border-0 rounded-0 mm-default-text">
    <div class="modal-header mm-modal-header rounded-0">
        <h6 class="modal-title">Password Reset</h6>
        <button type="button" class="btn-close btn-close-white opacity-100" aria-label="Close" (click)="dismiss()">
        </button>
    </div>
    <div class="modal-body">
        <lib-alert-banner
            *ngIf="hasNotification"
            [alertType]="notificationAlertType"
            [hidden]="false"
            [maxWidth]="'100%'"
            [message]="notificationMessage"
            class="d-block mb-3">
        </lib-alert-banner>

        <p>{{ warningMessage }}</p>
        <ul>
            <li *ngFor="let item of modalMessageList">{{ item }}</li>
        </ul>

        <div class="mt-3" [formGroup]="confirmationForm">
            <label for="modalResetConfirmInput" class="form-label">
                Type "{{ confirmationWord }}" to confirm this action
            </label>
            <input id="modalResetConfirmInput"
                   type="text"
                   class="form-control w-45"
                   autocomplete="off"
                   [class.is-invalid]="confirmationText?.errors?.['confirmationMismatch'] && confirmationText?.dirty"
                   formControlName="confirmationText">
            <div *ngIf="confirmationText?.errors?.['confirmationMismatch'] && confirmationText?.dirty"
                 class="invalid-feedback">
                Please type {{ confirmationWord }} exactly to confirm.
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-default" (click)="decline()">Cancel</button>
        <button type="button"
                class="btn btn-sm btn-primary"
                [disabled]="!isResetEnabled"
                (click)="accept()">
            <span *ngIf="isResetPasswordProcessing" class="spinner-border spinner-border-sm me-1" role="status"></span>
            {{ isProcessing() ? 'Processing Password Reset...' : (isResetInProgress ? 'Resetting Passwords...' :
                `Reset All ${totalUserCount} Account Password${totalUserCount !== 1 ? 's' : ''}`) }}
        </button>
    </div>
</div>
